<template>
    <div class="vx-card px-6 py-6 mb-5 shadow-sm">
        <div class="card-content">
            <div class="card-body">
                <div class="flex">
                    <div class="w-1/4">
                        <img :data-src="job.company.logo" style="height:100px; width:100px; border-radius:5px;" class="card-img-bottom img-fluid lazyload" :alt="job.company.name">
                    </div>
                    <div class="w-3/4">
                        <h4 class="card-title mb-3 break-all">{{ job.title }}</h4>
                        <button type="button" name="button" class="vs-component vs-button vs-button-success vs-button-filled">
                            <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 49px; top: 27px; width: 0px; height: 0px; transition: width 0s ease 0s, height 0s ease 0s, opacity 0s ease 0s;"></span>
                            <span class="vs-button-text vs-button--text">{{ job.job_type }}</span>
                            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                        </button>
                        <div class="flex mt-4">
                            <p class="w-1/2"><i class="feather icon-align-justify"></i> {{ job.company.name }}</p>
                            <p class="w-3/4"><i class="feather icon-map-pin"></i> {{ job.location.name }}</p>
                        </div>
                        <button type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled mt-6">
                            <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 49px; top: 27px; width: 0px; height: 0px; transition: width 0s ease 0s, height 0s ease 0s, opacity 0s ease 0s;"></span>
                            <span class="vs-button-text vs-button--text">Posted {{ job.posted_at }}</span>
                            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props : {
        job : {
            type : Object,
            required : true,
        }
    }
}
</script>